<template>
  <div>
    <svg :id="id"></svg>
  </div>
</template>

<script>
import * as d3 from "d3";
import * as d3Collection from "d3-collection";
import jquery from 'jquery';

export default {
  props: ["issues","graphicTitle","router","propertyName","filtroRicerca","um"],
  data() {
    return {
      id: null,
      chart: null,
      rawIssues: null,
      rawGraphicTitle: null,
      rawRouter: null,
      rawPropertyName: null,
      rawFiltroRicerca: null,
      rawUm: null,
      jquery,
    };
  },
  watch: {
    issues(val) {
      if (this.chart != null) this.chart.remove();
      this.renderChart(val,this.rawGraphicTitle,this.rawRouter,this.rawPropertyName,this.rawFiltroRicerca,this.rawUm);
    }
  },
  methods: {
    renderChart(issuesVal,graphicTitle,router,propName,filtroRicerca,um) {
      if (issuesVal != undefined) {
        // set the dimensions and margins of the graph
        const margin = 50;
        const svgWidth = 1100;
        const svgHeight = 530;
        const svgMargin = 60;
        const chartWidth = svgWidth - 2 * margin;
        const chartHeight = svgHeight - 2 * margin;

        // The radius of the pieplot is half the width or half the height (smallest one). I subtract a bit of margin.
        const radius = Math.min(svgWidth, svgHeight) / 2 - svgMargin;

        const svg = d3
          .select("#" + this.id)
          .attr("width", svgWidth)
          .attr("height", svgHeight)

        this.chart = svg
          .append("g")
          .attr("transform", "translate(" + svgWidth / 2 + "," + svgHeight / 2 + ")");

        jquery(".pie-tooltip").remove();
        var tooltip = jquery("<div></div>").addClass("chart-tooltip pie-tooltip");
        tooltip.hide();
        jquery("body").append(tooltip);

        // Create data: data dev'essere così formattato: {k1:v1, k2:v2, ..., kn:vn};
        let data = {};
        let dataCode = {};
        issuesVal.forEach(function(i) {
          data[i.description] = i.value;
          dataCode[i.description] = i.code;
        });

        // set the color scale
        var color = d3.scaleOrdinal(["#366079", "#679dba"]);

        // Compute the position of each group on the pie:
        let pie = d3.pie()
          .value(function(d) {return d.value; });
        let dataReady = pie(d3Collection.entries(data));

        let path = d3.arc()
          .outerRadius(radius - 10)
          .innerRadius(radius/2);

        let label = d3.arc()
          .outerRadius(radius - 40)
          .innerRadius(radius - 40);

        // Build the pie chart: Basically, each part of the pie is a path that we build using the arc function.
        let arc = this.chart.selectAll(".arc")
          .data(dataReady)
          .enter()
          .append("g")
          .attr("class", "arc");

        arc.append("path")
          .attr("stroke", "white")
          .style("stroke-width", "2px")
          .style("opacity", 0.7)
          .attr("d", path)
          .style("fill", function(d,i) { return color(d.data.key); });

        arc.append("text")
          .attr("transform", function(d){return "translate(" + label.centroid(d) + ")"; })
          .style("font-size","20px")
          .attr("dy", "0.35em")
          .attr('text-anchor', 'middle')
          .text(function(d,i) {return d.data.value + um; })
          .style("fill", "white");

        arc.on("mouseover", function(event, d) {
          d3.select(this)
            .attr("stroke-width", 2)
            .attr("stroke", "red");

          const t = `${d.data.key} : ${d.data.value}`;
          jquery(".pie-tooltip")
            .html(t)
            .css("left", (event.pageX) + "px")
            .css("top", (event.pageY - 28) + "px")
            .show(200);
        })
          .on("mouseout", function() {
            d3.select(this)
              .attr("stroke", "none");

            jquery(".pie-tooltip").hide();
          })
          .on("click", function (d,i) {
            filtroRicerca[propName] = [{code: dataCode[i.data.key], description: i.data.key}];

            router.push({ name: 'database-danni-non-auto', params: { filters: filtroRicerca} });
          });

        /*svg
          .append('text')
          .attr('class', 'title')
          .attr('x', chartWidth/2 + margin)
          .attr('y', 40)
          .attr('text-anchor', 'middle')
          .attr('stroke', '#366079')
          .style("text-shadow", "none")
          .text(graphicTitle)*/

        var legendG = svg.selectAll(".legend")
          .data(pie(d3Collection.entries(data)))
          .enter().append("g")
          .attr("transform", function(d,i){
            return "translate(" + (svgWidth - 170) + "," + (i * 15 + 200) + ")";
          })
          .attr("class", "legend");
        
        legendG.append("rect")
          .attr("width", 10)
          .attr("height", 10)
          .attr("fill", function(d, i) {
            return color(d.data.key);
          });
        
        legendG.append("text")
          .text(function(d){
            return d.data.key;
          })
          .style("font-size", 12)
          .attr("y", 10)
          .attr("x", 15);
      }
    }
  },
  created() {
    this.id = "uid" + this._uid;
  },
  mounted() {
    this.rawIssues = this.issues;
    this.rawGraphicTitle = this.graphicTitle;
    this.rawRouter = this.router;
    this.rawPropertyName = this.propertyName;
    this.rawFiltroRicerca = this.filtroRicerca;
    this.rawUm = this.um;
    this.renderChart(this.rawIssues,this.rawGraphicTitle, this.rawRouter, this.rawPropertyName,this.filtroRicerca,this.rawUm);
  },
  beforeDestroy() {
    jquery(".pie-tooltip").remove();
  },
};
</script>
